import { useQuery } from 'react-apollo';
import { useMemo } from 'react';
import { get } from 'lodash';
import queryGql from '../withCurrentUser.graphql';
const useCurrentUser = () => {
    const { data, error, loading } = useQuery(queryGql, {
        fetchPolicy: 'cache-first',
    });
    const me = useMemo(() => get(data, 'me', {}), [data]);
    const systemConfig = useMemo(() => get(data, 'systemConfig', {}), [data]);
    return {
        me,
        systemConfig,
        currentUser: me,
        error,
        loading,
    };
};
export default useCurrentUser;
